// You can write more code here

import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  getAnchorPlugin,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';
import LevelMap from '@/game/scenes/LevelMap';
import DefaultButton from '../GeneralUI/Buttons/DefaultButton';

/* START OF COMPILED CODE */

export default class DuelEndUI extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(scene, 512, 384);
    uIBlocker.scaleX = 3200;
    uIBlocker.scaleY = 2048;
    uIBlocker.setOrigin(0.5, 0.5);
    this.add(uIBlocker);

    // mainContainer
    const mainContainer = scene.add.container(512, 384);
    this.add(mainContainer);

    // nineslice_1
    const nineslice_1 = scene.add.nineslice(
      0,
      0,
      'Hud1',
      undefined,
      96,
      48,
      8,
      8,
      8,
      8,
    );
    nineslice_1.scaleX = 4;
    nineslice_1.scaleY = 4;
    mainContainer.add(nineslice_1);

    // defaultButton
    const defaultButton = new DefaultButton(scene, 0, 48);
    mainContainer.add(defaultButton);

    // duelEndText
    const duelEndText = scene.add.bitmapText(
      0,
      -16,
      'Pixellari',
      'Duel Complete!',
    );
    duelEndText.setOrigin(0.5, 0.5);
    duelEndText.tintTopLeft = 5387071;
    duelEndText.tintTopRight = 5387071;
    duelEndText.tintBottomLeft = 5387071;
    duelEndText.tintBottomRight = 5387071;
    duelEndText.text = 'Duel Complete!';
    duelEndText.fontSize = -32;
    mainContainer.add(duelEndText);

    // defaultButton (prefab fields)
    defaultButton.buttonText = 'OK';

    this.defaultButton = defaultButton;
    this.duelEndText = duelEndText;
    this.mainContainer = mainContainer;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private defaultButton: DefaultButton;
  private duelEndText: Phaser.GameObjects.BitmapText;
  private mainContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  awake() {
    this.defaultButton.controller.setSubmissionCallback(() => {
      this.handleSubmitButtonPressed();
    });

    this.setVisible(false);

    // Responsiveness.
    this.initializeResponsiveness();

    EventsManager.registerEventOn(
      this.scene,
      GAME_EVENTS.DUELIST_WAS_DEFEATED,
      this.handleDuelEnded,
      this,
    );

    return this;
  }

  async handleDuelEnded(payload: any) {
    await waitForSeconds(this.scene.time, 2);
    this.setVisible(true);
    if (payload.duelist.index === 0) {
      // The player was defeated.
      this.duelEndText.setText('Defeat!');
    } else {
      // an opponent was defeated.
      this.duelEndText.setText('Victory!');
      PhaserAudioManager.playSFX(this.scene, 'duel-victory');
    }
  }

  async initializeResponsiveness() {
    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      anchor.add(this.mainContainer, {
        centerX: '50%',
        centerY: '50%',
      });
    }

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.mainContainer,
      DEFAULT_SCALE_DOWN_CONFIG,
    );
  }

  handleSubmitButtonPressed() {
    getSceneManager()?.launchScene('LevelMap', LevelMap, {
      type: 'gameplay',
      stopActiveScene: true,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
